import React , { useContext }  from 'react'
import firebaseApp from './firebaseApp'
import firebase from 'firebase/app'
import './style/commonStyle.css';
import './style/dashboard.css';

import logo from './assets/logo.png'
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import MenuIcon from "@material-ui/icons/Menu";
import ListItem from "@material-ui/core/ListItem";
import Toolbar from "@material-ui/core/Toolbar";
import List from "@material-ui/core/List";
import Drawer from "@material-ui/core/Drawer";
import clsx from "clsx";
import Grid from '@material-ui/core/Grid';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import { Link } from 'react-router-dom';


import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";


function ListItemLink(props) {
  return <ListItem button component="a" {...props} />;
}


function DisplayHeaderContent(){
    const username = firebaseApp.auth().currentUser.displayName;
    
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var email = user.email;
    }
    
    //default data for new users
    var docData = {
        blacklist: [],
        whitelist: [],
        timestamp: Date.now(),
        name: user.displayName,
        email: user.email,
        id: user.uid
    };

    var securityData = {
        email: user.email,
        predictions: [],
    };
    
    React.useEffect(() => 
    {
        //get database
        const db = firebaseApp.firestore()

        //login document creation
        var userRef = db.collection('users').doc(email);
        userRef.get().then(function(doc)
        {
             //if user does not exists in our database
             if(!doc.exists)
             {
                db.collection('users').doc(email).set(docData, {merge: true}) 
             }
            
        }).catch(function(error)
        {
            console.log("error is " + error);
        })  
        
        var securityEventsRef = db.collection('securityEvent').doc(email);
        securityEventsRef.get().then(function(doc)
        {
            //if user does not exists in our database
            if(!doc.exists)
            {
                db.collection('securityEvent').doc(email).set(securityData, {merge: true}) 
            }
        })
        
    },[])
    

    return(
      <>
        <div className="headerContent">
            <img src={logo} className="App-logo" alt="logo" /> 
            <div className="headerTitle">
                Welcome <b>{username}</b> <br/>
                <hr />
                <i>How are you today?</i>
            </div>
        </div>
    </>
    );
}

function MenuLink(){
    
    const user = firebaseApp.auth().currentUser;    

    if (user != null) {
        var username = user.displayName;
        var email = user.email;
        var photoUrl = user.photoURL;
    }

    const [open, setOpen] = React.useState(false);
    
    const handleDrawerOpen = () => {
        setOpen(true);
    };

    const handleDrawerClose = () => {
        setOpen(false);
    };

    return(
        <div className="menu"> 
            <Toolbar>
                <IconButton
                    aria-label="menu"
                    onClick={handleDrawerOpen}
                    edge="start"
                    className={clsx(open && "menuHide")}
                >
                    <div className="material-icons menuIcon">menu</div>
                </IconButton>
            </Toolbar>
            <Drawer
                className="menuSection"
                anchor="left"
                onClose={handleDrawerClose}
                open={open}
                classes={{
                    paper: "menuLinkPaper",
                }}
            >
                <div className ="expandMenuSection" >
                    <div className="menuLinkHeader">
                        <IconButton onClick={handleDrawerClose}>
                            <MenuIcon className="menuIconStyle"/>
                        </IconButton>
                    </div>
                    <div className="con">
                        <div className="displayUserInformation">
                            <div className="googleProfilePicSection">
                                <img alt="profile pic icon" src={photoUrl} className="googleProfilePic" />
                                <Link to ="/profile">
                                    <div className="btnView"><p>View</p></div>
                                </Link>
                            </div>
                            <div className="loginDetails">
                                <h3 className="username">{username} </h3>
                                <h5 className="emailAddress"><i>{email}</i></h5>
                            </div>
                        </div>
                    </div>
                    <Divider />
                    <List className="listSection">
                        <ListItemLink className="menuLink" href="/dashboard">
                            DASHBOARD
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/securityEvents">
                            SECURITY EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/emailList">
                            BLACKLIST / WHITELIST
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/events">
                            YOUR EVENTS
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/policy">
                            OUR POLICY
                        </ListItemLink>
                        <ListItemLink className="menuLink" href="/newUserSetup">
                            INSTALLATION
                        </ListItemLink>
                    </List>
                </div>
            </Drawer>
        </div>
    );
}

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function DisplayInstallationNotice()
{
    //ok open is the dialog with ok button after user clicks on confirm
    const [open, setOpen] = React.useState(true);

    const handleClose = () => {
      setOpen(false);
    };

    return(
        <>      
        <div>
            <Dialog
                open={open}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleClose}
                aria-labelledby="alert-dialog-slide-title"
                aria-describedby="alert-dialog-slide-description"
                align = "center"
            >                              
            <DialogTitle>
                <h3>NOTICE</h3>
            </DialogTitle>                      
                <DialogContent>
                    <DialogContentText className="alert-dialog-notice-description">
                        <b>[New User / Existing User]</b> <br />
                        Please select <b>INSTALLATION</b> located at the side menu. <br />
                        If you've not been through the setup.
                    </DialogContentText>
                </DialogContent>
                <DialogActions className="dialogBtnSection">
                    <Button className="btnOk" onClick={handleClose}>
                        <b>Close</b>
                    </Button>
                </DialogActions>
            </Dialog>
            
        </div>
    </>
    );
}



function GetSecurityEventsData() 
{

    const[securityEvents, setSecurityEvent] = React.useState([])
    var securityData = []
    React.useEffect(() => 
    {
        //get database
        const db = firebaseApp.firestore()

        //get users email
        const user = firebaseApp.auth().currentUser;    
        if (user != null) {
            var email = user.email;
        }
        
        var securityEventsRef = db.collection('securityEvent').doc(email);
        securityEventsRef.get().then(function(doc)
        {
            //if user exists in our database
            if(doc.exists)
            {
                //get events from user
                db.collection('securityEvent').doc(email).onSnapshot( function(doc) 
                {
                    setSecurityEvent(doc.data().predictions.reverse())
                })
            }
        }).catch(function(error)
        {
            console.log("error is " + error);
        })                                                             
    },[])

    securityEvents.map((row) => (
        securityData.push(row.predict)
    ))

    return(
         <>
         <DisplayStatistic securityData = {securityData}/>
         <DisplaySecurityEvent securityEvents = {securityEvents} />
         </>
    );
  
}

function DisplayStatistic(props){

    var ham = 0;
    var spam = 0;
    
    for(var i = 0; i < props.securityData.length; i++)
    {
        if(props.securityData[i] === "ham")
        {
            ham++;
        }
        else {
            spam++;
        }
    }

    return (
        
        <Grid className="eventContainer">
            <Grid xs className="gridContainer">
                <div className="eventContent">
                    DETECTED
                    <h3 style={{color:"green"}}>{ham}</h3>
                    <h3 style={{color:"green"}}>SAFE EMAILS</h3>
                </div>
            </Grid>
            <Grid xs className="gridContainer">
                <div className="eventContent">
                    DETECTED
                    <h3 style={{color:"brown"}}>{spam}</h3>
                    <h3 style={{color:"brown"}}>TOTAL PHISHING EMAILS</h3>
                </div>
            </Grid>
        </Grid>
        
    );
}

function GetEventsData() 
{
    const[events, setEvent] = React.useState([])
   
    React.useEffect(() => 
    {
        //get database
        const db = firebaseApp.firestore()

        //get users email
        const user = firebaseApp.auth().currentUser;    
        if (user != null) {
            var email = user.email;
        }

        var eventsData = {
            events: [],
            name: firebase.auth().currentUser.displayName,
            id: firebase.auth().currentUser.uid,
        };

        var eventsRef = db.collection('events').doc(email);
        eventsRef.get().then(function(doc)
        {
            //if user exists in our database
            if(doc.exists)
            {
                //get events from user
                db.collection('events').doc(email).onSnapshot( function(doc) 
                {
                    //code for event here
                    setEvent(doc.data().events.reverse())
                })
            }
            else
            {
                console.log("user doesnt exist creating default events");
                db.collection('events').doc(email).set(eventsData, {merge: true}) 
            }
          
        }).catch(function(error)
        {
            console.log("error is " + error);
        })  
       
                                                                                
    },[])
    return(
         // pass in current element events to DisplayUserEvent
        <DisplayUserEvent events = {events} />
    );
  
}

function DisplayUserEvent(props){
 
    return(
        <div className="userEventTable" >
        <Table>
          <TableHead>
            <TableRow className="tableRow">
              <TableCell component="th" colspan="3" className="tableHeader"><b>Your Events</b></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {props.events.map((row) => (
                <TableRow key={row.target}>
                    <TableCell align="left">{row.date}</TableCell>
                    <TableCell align="left">{row.time}</TableCell>
                    <TableCell align="left">
                        <DisplayEventContent action={row.action} target={row.target} list={row.list}/>
                    </TableCell>
                </TableRow>
            ))}
          </TableBody>
        </Table>
    </div>
    );
}

function DisplayEventContent(props){
    var first;
    var middle;
    var last;

       
    if(props.action === "Unmarked Whitelist")
    {
        first = "Unmarked email"
        middle = " '" + props.target + "' "
        last =  "from " + props.list + " tab."
    }
    else if(props.action === "Unmarked Blacklist")
    {
        first = "Unmarked email"
        middle = " '" + props.target + "' "
        last =  "from " + props.list + " tab."
    }
    else if(props.action === "phishing"){
        first = "Marked sender email"
        middle = " '" + props.target + "' "
        last =  "as phishing email from phishy extension."
    
    }
    else if (props.list === "whitelist") {
        first = "Whitelisted sender email"
        middle = " '" + props.target + "' "
        last =  "from phishy extension."
    }
    else if (props.list === "blacklist") {
        first = "Blacklisted sender email"
        middle = " '" + props.target + "' "
        last =  "from phishy extension."
    }

    return (
        <>
            {first} 
            <br />
            <b>{middle}</b> 
            <br />
            {last} 
        </>
    )

}

function DisplaySecurityEvent(props){

    return(
        <TableContainer class="securityEventTable">
            <Table aria-label="security event table">
                <TableHead>
                    <TableRow className="tableRow">
                        <TableCell component="th" colspan="4" className="tableHeader"><b>Security Events</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                {props.securityEvents.map((row) => (
                    <TableRow>
                        <TableCell align="left">{row.date}</TableCell>
                        <TableCell align="left">{row.time}</TableCell>
                        <TableCell align="center" className="icon">
                            {row.predict === "ham" ? <img src="https://static.wixstatic.com/media/aa8b91_9c37979f2dba4e8d93c748a6b5cce395~mv2.png" className="safeIconStatus" alt="safe icon" /> : 
                            <img src="https://static.wixstatic.com/media/aa8b91_225296f2f317485f8611dc61a4291436~mv2.png" className="unsafeIconStatus" alt="unsafe icon" /> }  
                            <br/>
                             {row.predict === "ham" ? <span className="ham"><b> Verification Safe </b></span> : <span className="spam"><b> Verification Failed  </b></span>}               
                        </TableCell>
                        <TableCell align="left">
                            Predicted the sender <b>'{row.senderEmail}'</b> mail as 
                            {row.predict === "ham" ? <span className="ham"><b> Ham </b> </span> : <span className="spam"><b> Spam  </b> </span>} mail.
                        </TableCell>
                    </TableRow>
                ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
}

function Logout(){
    return(
        <div className="btnLogout">
            <IconButton
            aria-label="exit icon"
            edge="start"
            href="/logout"
            >
                <div className="material-icons exitIcon">
                   exit_to_app
                </div>
            </IconButton>
        </div>
    );
}

function Copyright()
{
    return (
      <>
        {'Copyright © '}
        <Link to="https://isitphishy.wixsite.com/website" target="_blank">
            Phishy
        </Link>{' '}
        {new Date().getFullYear()}
        {'.'}
      </>
    );
}

function Dashboard() 
{
    if (typeof Storage !== "undefined") {
        if (localStorage.visitcount) {
         
          localStorage.visitcount = Number(localStorage.visitcount) + 1;
        } else {
          localStorage.visitcount = 1;
         
        }
    } else {
        alert("Sorry, your browser does not support web storage.  Changes will not be saved");
    }

    return (
        <>
        
        <div className="topSectionBackground">
            <div className="topContentBackground">
                <DisplayHeaderContent />
                <MenuLink />
                <Logout />
            </div>
        </div>
        <div className="dashboardContent">
            {localStorage.visitcount === "1" ? <DisplayInstallationNotice /> : " "}
            <GetSecurityEventsData />
            <GetEventsData />
            
        </div>
        <div className="footer">
            <Copyright />
        </div>
        </>
    )
}

export default Dashboard;

